import {TAB_SELECTED2, TAB_NEW2} from "./tabsConstants2";

export function selectTab2(tabName) {
    return {
        type : TAB_SELECTED2,
        payload : {tabName},
    };
}

export function newTab2(tabName) {
    return {
        type : TAB_NEW2,
        payload : {tabName},
    };
}